import { createFileRoute } from "@tanstack/react-router";
import { AnnouncementBar } from "@/components/home/AnnouncementBar";
import { Navbar } from "@/components/home/Navbar";
import { Footer } from "@/components/home/Footer";
import { CraftBanner } from "@/components/home/CraftBanner";
import { WhyChoose } from "@/components/home/WhyChoose";
import lux from "@/assets/1742561569_3593189334595606656.webp";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About — Royal Lumina" },
      { name: "description", content: "Royal Lumina is a small Indian atelier hand-pouring luxury scented candles for quiet, cinematic rituals." },
      { property: "og:title", content: "About — Royal Lumina" },
      { property: "og:description", content: "A small atelier for cinematic candle rituals." },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <AnnouncementBar />
      <Navbar />

      <section className="relative bg-primary text-cream -mt-20 pt-32 pb-16">
        <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_20%_30%,var(--gold)_0%,transparent_45%)]" />
        <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="text-xs tracking-[0.3em] uppercase text-gold/80">Home · About</div>
          <h1 className="mt-4 font-display text-5xl md:text-6xl lg:text-7xl">Our <span className="italic text-gold">Story</span></h1>
          <p className="mt-4 max-w-xl text-cream/70">A small atelier, a hundred hand-poured rituals, one very steady flame.</p>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-20 lg:py-28 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative aspect-[4/5] rounded-[24px] overflow-hidden shadow-luxe">
          <img src={lux} alt="The atelier" className="h-full w-full object-cover" />
        </div>
        <div>
          <p className="eyebrow">Founded 2019</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl">Candles as <span className="italic text-gold">quiet architecture</span>.</h2>
          <p className="mt-6 text-muted-foreground leading-relaxed">Royal Lumina began in a Mumbai studio with three copper pans, a small library of essences, and a stubborn belief that a room deserves a soundtrack. Every candle is poured in small batches, aged for seven days, and hand-inspected before its ribbon is tied.</p>
          <p className="mt-4 text-muted-foreground leading-relaxed">We work with a network of Indian farmers and French perfumers to blend fragrances that feel both intimate and cinematic — floral without being sweet, woody without being heavy.</p>
        </div>
      </section>

      <CraftBanner />
      <WhyChoose />
      <Footer />
    </div>
  );
}
